import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// get Opening Balances
export const getOpeningBalances = createAsyncThunk(
  "OpeningBalance/getOpeningBalances",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");

      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);
      if (params.status) queryParams.append("status", params.status);

      const url = `${BASE_URL}/opening-balance${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "فشل في جلب الأرصدة الافتتاحية!";
      return rejectWithValue(message);
    }
  },
);

// add opening balance

export const addOpeningBalance = createAsyncThunk(
  "OpeningBalance/addOpeningBalance",
  async (data, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");

      const headers = {
        Authorization: `Bearer ${token}`,
        "Accept-Language": currentLang,
      };

      if (data instanceof FormData) {
        if (!data.has("details")) {
          data.append("details", JSON.stringify([]));
        } else {
          const detailsValue = data.get("details");
          if (typeof detailsValue !== "string") {
            data.set("details", JSON.stringify(detailsValue));
          }
        }

        const response = await axios.post(`${BASE_URL}/opening-balance`, data, {
          headers,
        });
        return response.data;
      }

      headers["Content-Type"] = "application/json";
      const payload = {
        ...data,
        details:
          typeof data.details === "string"
            ? data.details
            : JSON.stringify(data.details || []),
      };
      const response = await axios.post(
        `${BASE_URL}/opening-balance`,
        payload,
        {
          headers,
        },
      );
      return response.data;
    } catch (error) {
      let message = "فشل في إضافة الرصيد الافتتاحي!";
      if (error.response?.data) {
        const err = error.response.data;
        if (typeof err === "string") message = err;
        else if (err.message) message = err.message;
        else message = JSON.stringify(err);
      }
      return rejectWithValue(message);
    }
  },
);

// update opening balance

export const updateOpeningBalance = createAsyncThunk(
  "OpeningBalance/updateOpeningBalance",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");

      const headers = {
        Authorization: `Bearer ${token}`,
        "Accept-Language": currentLang,
      };

      if (data instanceof FormData) {
        if (!data.has("id")) {
          data.append("id", id);
        }
        if (data.has("details")) {
          const detailsValue = data.get("details");
          if (typeof detailsValue !== "string") {
            data.set("details", JSON.stringify(detailsValue));
          }
        } else {
          data.append("details", JSON.stringify([]));
        }

        const response = await axios.post(`${BASE_URL}/opening-balance`, data, {
          headers,
        });
        return response.data;
      }

      headers["Content-Type"] = "application/json";
      const payload = {
        ...data,
        details:
          typeof data.details === "string"
            ? data.details
            : JSON.stringify(data.details || []),
      };
      const response = await axios.post(
        `${BASE_URL}/opening-balance`,
        {
          id,
          ...payload,
        },
        {
          headers,
        },
      );
      return response.data;
    } catch (error) {
      let message = "فشل في تحديث الرصيد الافتتاحي!";
      if (error.response?.data) {
        const err = error.response.data;
        if (typeof err === "string") message = err;
        else if (err.message) message = err.message;
        else message = JSON.stringify(err);
      }
      return rejectWithValue(message);
    }
  },
);

// post opening balance

export const postOpeningBalance = createAsyncThunk(
  "OpeningBalance/postOpeningBalance",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");

      const response = await axios.post(
        `${BASE_URL}/opening-balance/post`,
        { id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "فشل في ترحيل الرصيد الافتتاحي!";
      return rejectWithValue(message);
    }
  },
);

// delete opening balance
export const deleteOpeningBalance = createAsyncThunk(
  "OpeningBalance/deleteOpeningBalance",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");

      const response = await axios.delete(`${BASE_URL}/opening-balance`, {
        data: { id },
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "فشل في حذف الرصيد الافتتاحي!";
      return rejectWithValue(message);
    }
  },
);

// get Opening Balance Details
export const getOpeningBalanceDetails = createAsyncThunk(
  "OpeningBalance/getOpeningBalanceDetails",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");

      const response = await axios.get(`${BASE_URL}/opening-balance/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "فشل في جلب تفاصيل الرصيد الافتتاحي!";
      return rejectWithValue(message);
    }
  },
);
